import { jsx as _jsx } from "react/jsx-runtime";
import { PropertyCardSkeleton } from '@awaze/design-system.compositions.property-card';
import { StyledPropertyList } from './property-list.styles';
/**
 *
 * The property list skeleton component is a list of property card skeleton components, intended to be used as a loading state, whilst search results are being fetched.
 *
 * It is currently used as part of the Property List component and will be displayed when the loading state is set to `true`
 */
export const PropertyListSkeleton = ({ resultsPageSize = 12, }) => {
    return (_jsx(StyledPropertyList, { "aria-label": "properties loading", "data-testid": "property-list-loader", children: Array(resultsPageSize)
            .fill('')
            .map((_, i) => (_jsx("li", { children: _jsx(PropertyCardSkeleton, {}) }, i))) }));
};
export default PropertyListSkeleton;
//# sourceMappingURL=property-list-skeleton.js.map